module.exports = __webpack_public_path__ + "static/media/Luggage.9db8068f.png";